import * as React from "react";
import { UitkLayoutFlexItem, UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkCheckbox } from "uitk-react-switch";
import { ILOBCheckbox, TypeMenuProps } from "../typings";

export const TypeMenuCheckboxes = ({ useLink, handleMenuChange, lobsMap, lobKeys, className }: TypeMenuProps) => {
  const renderCheckbox = (key: string, { checked, ref, id, label }: ILOBCheckbox) => {
    const onChangeCheckbox = () => {
      handleMenuChange(key, ref, id);
    };

    return (
      <UitkCheckbox id={!useLink ? `package-pills-${key}` : ""} checked={checked} onChange={onChangeCheckbox}>
        {label}
      </UitkCheckbox>
    );
  };

  const checkboxesToLoad = () => {
    return lobKeys.map((lobKey) => {
      const lobCheckbox: ILOBCheckbox = lobsMap[lobKey];
      const checkboxToLoad = renderCheckbox(lobKey, lobCheckbox);
      const classes = useLink ? "all-x-margin-three ssr-link-pill" : "all-r-margin-four";

      return (
        <div key={lobKey} className={classes} data-testid="type-menu-checkboxes">
          {checkboxToLoad}
        </div>
      );
    });
  };

  return (
    <UitkLayoutFlexItem className={className}>
      <UitkLayoutFlex direction="row">{checkboxesToLoad()}</UitkLayoutFlex>
    </UitkLayoutFlexItem>
  );
};
